exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/@front10/healthcare-book/src/app/components/address-selector/address-selector.scss
// module id = 510
// module chunks = 0